module.exports = __webpack_public_path__ + "static/img/image-3.17447022.png";